export default __webpack_public_path__ + "static/media/balonove-kreacie.884fd120.svg";